import R from 'ramda'

const OVERLAY_IMAGE_ACTION_TYPE = 'OVERLAY_IMAGE'
const OVERLAY_IMAGE_DISPLAY_TYPE = 'Send overlay'

const isOverlayImageWidgetAction = R.propEq('type', OVERLAY_IMAGE_ACTION_TYPE)

const getOverlayMediaId = R.pipe(
  R.ifElse(
    R.has('overlayMediaId'),
    R.pipe(R.prop('overlayMediaId'), R.of),
    R.always(undefined)
  )
)

const convertOverlayImageWidgetActionToFormAction = R.applySpec({
  type: R.always(OVERLAY_IMAGE_DISPLAY_TYPE),
  overlayType: R.prop('type'),
  message: R.prop('message'),
  isPromotedTweet: R.prop('isPromotedTweet'),
  overlayMediaId: getOverlayMediaId
})

export {
  isOverlayImageWidgetAction,
  convertOverlayImageWidgetActionToFormAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/overlay-image.js